import CRUD from './genericCRUD'

const route = 'transport_types'
/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function transportTypes(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllPaged: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `page?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`transport_types/${params}`, config)
		}
	}
}
